import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type SegmentAnswersTypes = {
  segment_id?: number;
  question_id: number | string;
  answer_id?: number;
  value?: string;
  valueRequired?: boolean;
};

type InitialState = {
  segmentAnswers: SegmentAnswersTypes[];
};

const initialState = {
  segmentAnswers: [],
} as InitialState;

export const segmentAnswersSlice = createSlice({
  name: "segmentAnswersSlice",
  reducers: {
    setSegmentAnswers: (state, action: PayloadAction<SegmentAnswersTypes>) => {
      const isExist = state.segmentAnswers.find(
        (prev) => prev.question_id === action.payload.question_id,
      );
      if (isExist) {
        state.segmentAnswers.filter(
          (segment) => segment.question_id !== action.payload.question_id,
        );
      }
      state.segmentAnswers.push(action.payload);
    },
  },
  initialState,
});

export const { setSegmentAnswers } = segmentAnswersSlice.actions || {};

export default segmentAnswersSlice.reducer;
